// extracted by mini-css-extract-plugin
module.exports = {"button":"_82e3db2ea0--button--GVLSF"};